<template>
  <van-overlay show z-index="1000">
    <div class="reward fixed inset-0 w-full h-full bg-white">
      <div class="error-tips text-center py-10">
        <template v-if="otherReceived">
          <p>该红包已被其他用户领取</p>
        </template>
        <template v-else-if="isBindOtherAnswer">
          <p>您已领取过该问卷的红包，请勿重复领取</p>
        </template>
        <template v-else-if="canGetRewards">
          <p>红包已发放，请前往公众号领取</p>
          <div class="text-gray-500 text-sm py-10">
            <p>如果已经领取红包，则无法重复领取</p>
          </div>
        </template>
        <template v-else-if="receivedOvertime">
          <p>很遗憾，红包已失效</p>
          <p>因您未在15分钟内未登记领奖信息</p>
          <p>红包已被释放</p>
        </template>
        <template v-else-if="auditing">
          <p>已登记领奖信息</p>
          <div class="text-gray-500 text-sm py-10">
            <p>问卷发布者审核答卷通过后</p>
            <p class="py-4">红包将以微信红包形式发放，请耐心等待</p>
          </div>
        </template>
        <template v-else>
          <p>已登记领奖信息</p>
          <div class="text-gray-500 text-sm py-10">
            <p>问卷发布者审核答卷通过后</p>
            <p class="py-4">红包将以微信红包形式发放，请耐心等待</p>
          </div>
        </template>
      </div>
      <div class="absolute bottom-0 text-center w-full">
        <template v-if="!params.otherReceived">
          <p class="mb-10 text-wjb" @click="onClickShowReward">查看领奖记录</p>
        </template>
        <p class="mb-4">如有疑问，请联系问卷发布者</p>
      </div>
    </div>
  </van-overlay>
</template>

<script>
const dzk = 0
const tg = 1
export default {
  name: 'AwardError',
  props: {
    data: Object
  },
  data() {
    return {
      otherReceived: false, // 是否其他人通过这个链接已经领取过
      canGetRewards: false, // 是否已经领取过奖励
      auditing: false, // 是否已经登记过领奖信息
      isBindOtherAnswer: false, // 是否绑定其他答卷
      receivedOvertime: false // 是否已经超时
    }
  },
  computed: {
    params() {
      return this.data
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let { otherReceived, bindThisAnswer, bindOtherAnswer, status, bindAnswerStatus, receivedOvertime } = this.data
      otherReceived = parseInt(otherReceived)
      bindOtherAnswer = parseInt(bindOtherAnswer)
      bindThisAnswer = parseInt(bindThisAnswer)
      status = parseInt(status)
      bindAnswerStatus = parseInt(bindAnswerStatus)
      receivedOvertime = parseInt(receivedOvertime)
      this.isBindOtherAnswer = Boolean(bindOtherAnswer)
      this.receivedOvertime = Boolean(receivedOvertime)
      this.otherReceived = Boolean(otherReceived)
      if (!isNaN(bindThisAnswer)) {
        this.canGetRewards = bindThisAnswer && status === tg
      } else {
        this.canGetRewards = status === tg
      }

      this.auditing = bindAnswerStatus && status === dzk
    },
    onClickShowReward() {
      window.location.replace(process.env.VUE_APP_WEBSITE + '/user/detailedList?token=' + this.params.token)
    }
  }
}
</script>
